var site = site || {};
site.ada = site.ada || {};

site.ada.config = site.ada.config || {};

/**
 * Function to handle waiting for an element to load on the page.
 * Once it's loaded, it will fire the callback with the element that was found.
 *
 * @param selector, string of the query used by querySelectorAll (ie '.randomClassName');
 * @param callback, callback of whatever you want to do to the element when it's loaded.
 */
site.ada.elementTimer = function(selector, callback) {
    const timer = setInterval(function() {
      const selectorQuery = document.querySelectorAll(selector);
      if (selectorQuery.length) {
        callback(selectorQuery);
        clearInterval(timer);
        clearTimeout(timeout);
      }
    }, 500);
  
    // Emergency bailout if nothing loads after 20 sec.
    const timeout = setTimeout(function() {
      clearInterval(timer);
    }, 20000);
  }

  /**
 * Function to handle switching a DOM Element and keeping all it's attributes.
 *
 * @param element, DOM node that will be switched out;
 * @param newElementString, string of new element that will used to replace (i.e. 'h1', 'h2' or 'div').
 */
site.ada.switchElement = function(element, newElementString) {
    const modifiedHeading = document.createElement(newElementString);
    Array.from(element.attributes).forEach(attr => {
      modifiedHeading.setAttribute(attr.nodeName, attr.nodeValue);
    })
    modifiedHeading.innerHTML = element.innerHTML;
    element.replaceWith(modifiedHeading);
  }

  /**
 * Function to handle outlining BazaarVoice review stars.
 * 
 * @param selector, string to pass to the elementTimer function (ie '.randomClassName');
 * 
 */
  site.ada.outlineStars = function(selector) {
  site.ada.elementTimer(selector, function(elements) {
    Array.from(elements).forEach(element => {
      element.setAttribute('stroke', 'black');
    })
  })
}

site.ada.observer = (nodeCheck, observerCallback, observedEl, observerConfig) => {
  var newObserver = new MutationObserver(function(mutations_list) {
    mutations_list.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(addedNode) {
        if (nodeCheck(addedNode)) { 
           observerCallback();
           newObserver.disconnect();
        }
      });
    });
  });
  
  newObserver.observe(observedEl, observerConfig);
}